import React from 'react';
import CabCrudPage from './CabCrudPage';
import useCabLookups from './useCabLookups';

const AdminCabsRoutes = () => {
  const { locations } = useCabLookups();
  const locationOptions = locations.map((loc) => ({ value: loc.id, label: `${loc.name} (${loc.city})` }));

  return (
    <CabCrudPage
      title="Routes"
      description="Maintain outstation routes and base distances."
      resource="routes"
      defaultItem={{
        fromLocationId: '',
        toLocationId: '',
        distanceKm: '',
        durationMins: '',
        isActive: true,
      }}
      columns={[
        {
          key: 'fromLocation',
          label: 'From',
          render: (row) => row.fromLocation?.name || '�',
        },
        {
          key: 'toLocation',
          label: 'To',
          render: (row) => row.toLocation?.name || '�',
        },
        { key: 'distanceKm', label: 'Distance (km)' },
        { key: 'durationMins', label: 'Duration (mins)' },
      ]}
      fields={[
        { name: 'fromLocationId', label: 'From location', type: 'select', required: true, options: locationOptions },
        { name: 'toLocationId', label: 'To location', type: 'select', required: true, options: locationOptions },
        { name: 'distanceKm', label: 'Distance (km)', type: 'number', required: true },
        { name: 'durationMins', label: 'Duration (mins)', type: 'number', required: true },
        { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
      ]}
    />
  );
};

export default AdminCabsRoutes;
